<template>
  <div class="user-list-box">
    <OperationBoxComponent :actions="actions" :filters="filters" :disabled="params.ids.length === 0" />
    <UserListComponent :page-data="pageData" @onSelectChanged="onSelectChanged" @onPageChanged="onPageChanged" />
  </div>
</template>

<script>
import OperationBoxComponent from '../../../components/common/OperationBoxComponent'
import GoodsListComponent from '../../../components/goods/GoodsListComponent'
import {UserRequestUtil} from '../../../utils/UserRequestUtil'
import UserListComponent from '../../../components/user/UserListComponent'

export default {
  name: 'UserListPage',
  components: {
    UserListComponent,
    GoodsListComponent,
    OperationBoxComponent
  },
  mounted () {
    this.updateUserList()
  },
  data () {
    return {
      actions: [
        { title: '', disabled: false, icon: 'el-icon-refresh', type: 'button', theme: 'primary', action: this.updateUserList },
        { title: '状态',
          type: 'select',
          action: this.onUserStateChange,
          options: [
            {title: '未授权', value: 0},
            {title: '已授权', value: 1},
            {title: '已禁止', value: 2}
          ]},
        { title: '应用',
          type: 'select',
          action: this.onAppChange,
          options: [
            {title: '二货', value: 'wx1dc8ad85d20d02eb'},
            {title: '去水印', value: 'wxb5c4c0d7adf90cbd'}
          ]}
      ],
      filters: [{searchValue: '', type: 'nickname', title: '昵称', action: this.onFilterChange}],
      pageData: {},
      params: {
        ids: []
      },
      queryParam: {
        page: 1,
        pageSize: 25,
        status: null,
        appid: null,
        type: null,
        keywords: null
      }
    }
  },
  methods: {
    updateUserList () {
      let that = this
      UserRequestUtil.queryUserList({queryParam: this.queryParam}, function (response) {
        if (response.items) {
          that.pageData = response
        }
      })
    },
    onUserStateChange (item) {
      this.queryParam.status = parseInt(item.selectValue)
      this.updateUserList()
    },
    onAppChange (item) {
      this.queryParam.appid = item.selectValue
      this.updateUserList()
    },
    onFilterChange (item) {
      this.queryParam.type = item.type
      this.queryParam.keywords = item.searchValue
      this.updateUserList()
    },
    onSelectChanged (ids) {
      this.params.ids = ids
    },
    onPageChanged (page) {
      this.queryParam.page = page
      this.updateUserList()
    }
  }
}
</script>

<style scoped lang="less">

</style>



// WEBPACK FOOTER //
// src/pages/whaledge/user/UserListPage.vue